export const caseDataProviderKey = Symbol();